import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ClinicalOnboardingService } from '../../../services/clinical-onboarding.service';
import { ToastService } from '../../../services/general/toast.service';
import { ClinicalOnboardingConfig } from '../../../models/clinical-onboarding.model';

/**
 * DBEK-392: pannello di configurazione dell'onboarding clinico per la survey -
 * abilita/disabilita la feature e imposta scadenza contrattuale/giorni di reminder
 * (piano §1, survey.customs.clinical_onboarding). Sempre visibile (a differenza di
 * Document Templates/Dashboard, mostrati solo quando gia' abilitato) perche' e'
 * l'unico punto da cui un gestore puo' ACCENDERE la feature la prima volta.
 */
@Component({
  selector: 'app-clinical-onboarding-config',
  templateUrl: './clinical-onboarding-config.component.html',
  styleUrls: ['./clinical-onboarding-config.component.scss'],
  standalone: false,
})
export class ClinicalOnboardingConfigComponent implements OnChanges {
  @Input() surveyId: string | number;
  @Input() config: ClinicalOnboardingConfig | null = null;
  @Output() configSaved = new EventEmitter<ClinicalOnboardingConfig>();

  saving = false;
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private clinicalOnboardingService: ClinicalOnboardingService,
    private toastService: ToastService,
    private translateService: TranslateService,
  ) {
    this.form = this.fb.group({
      enabled: [false],
      contract_deadline_days: [30],
      reminder_offsets_days: ['7, 20, 28'],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.config) {
      this.form.patchValue({
        enabled: this.config?.enabled ?? false,
        contract_deadline_days: this.config?.contract_deadline_days ?? 30,
        reminder_offsets_days: (this.config?.reminder_offsets_days ?? [7, 20, 28]).join(', '),
      });
    }
  }

  save(): void {
    const value = this.form.value;
    const offsets = String(value.reminder_offsets_days)
      .split(',')
      .map((s: string) => parseInt(s.trim(), 10))
      .filter((n: number) => !isNaN(n));

    const payload: ClinicalOnboardingConfig = {
      enabled: value.enabled,
      contract_deadline_days: value.contract_deadline_days,
      reminder_offsets_days: offsets,
    };

    this.saving = true;
    this.clinicalOnboardingService.updateConfig(
      this.surveyId,
      payload,
      () => {
        this.saving = false;
        this.toastService.success(
          this.translateService.instant('generic.success'),
          this.translateService.instant('components.clinical-onboarding.config.saved'),
        );
        this.configSaved.emit(payload);
      },
      () => {
        this.saving = false;
      },
    );
  }
}
